import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

AgencyContractEditView.propTypes = {
  contractDetail: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

function AgencyContractEditView(props) {
  // MARK: ---- PROPERTIES ----
  const { contractDetail, onCancel, onConfirm } = props;
  const [contractDate, setContractDate] = useState('');
  const [validFrom, setValidFrom] = useState(moment().format('YYYY-MM-DD'));
  const [validTo, setValidTo] = useState(moment().add(10, 'year').format('YYYY-MM-DD'));
  const [contractNumber, setContractNumber] = useState('');
  const [contractStatus, setContractStatus] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const selectFilePathList = useRef([]);
  const [allFiles, setAllFiles] = useState([]);
  const [contractType, setContractType] = useState(AgencyConstants.ContractType.DIGITAL);
  const [paperContractDocumentFile, setPaperContractDocumentFile] = useState(null);
  const [paperPOADocumentFile, setPaperPOADocumentFile] = useState(null);
  useEffect(() => {
    if (contractDetail) {
      setContractNumber(contractDetail.contractNumber);
      setContractStatus(contractDetail.status);
      setAllFiles(contractDetail?.attachedFiles ?? []);
      setContractType(contractDetail?.contractType ?? []);
      setPaperContractDocumentFile(contractDetail?.contractDocument);
      setPaperPOADocumentFile(contractDetail?.poaDocument);
      setContractDate(
        contractDetail?.contractDate
          ? Utils.formatDateTimeToString(contractDetail?.contractDate, 'YYYY-MM-DD')
          : ''
      );
      setValidFrom(
        contractDetail?.validFrom
          ? Utils.formatDateTimeToString(contractDetail?.validFrom, 'YYYY-MM-DD')
          : ''
      );
      setValidTo(
        contractDetail?.validTo
          ? Utils.formatDateTimeToString(contractDetail?.validTo, 'YYYY-MM-DD')
          : ''
      );
    }
  }, [contractDetail]);
  const [loading, setLoading] = useState(false);
  // MARK: ---- METHODS ----

  const getContractName = (contractNumber) => {
    const parts = (contractNumber || '').trim().split('/');
    const code = parts[2] || 'Không xác định';
    return `${code}_${parts[0] || ''}_${parts[1] || ''}_${code}.pdf`;
  };

  const handleUploadPaperContract = async (file, contractNumber) => {
    if (!file || !contractNumber) return;
    if (!(file instanceof File)) {
      return file;
    }

    const newFileName = getContractName(contractNumber);

    const renamedFile = new File([file], newFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });

    try {
      const mediaList = await AgencyHelper.API.requestUploadPaperContract(renamedFile);

      if (Array.isArray(mediaList) && mediaList.length > 0) {
        return mediaList[0]?.relativePath || null;
      }
      return null;
    } catch (error) {
      console.error('Upload thất bại:', error);
      return null;
    }
  }

  const handleConfirm = async () => {
    if (
      contractType === AgencyConstants.ContractType.PAPER &&
      contractDetail?.contractRole === AgencyConstants.SaleOrderType.GROUP &&
      (!paperContractDocumentFile || !paperPOADocumentFile)
    ) {
      ToastHelper.showError('Vui lòng tải lên hợp đồng scan và giấy uỷ quyền');
      return;
    }

    if (
      contractType === AgencyConstants.ContractType.PAPER &&
      (
        contractDetail?.contractRole === AgencyConstants.SaleOrderType.INVESTOR ||
        contractDetail?.contractRole === AgencyConstants.SaleOrderType.GROUP ||
        contractDetail?.contractRole === AgencyConstants.SaleOrderType.CHARGEPOINT
      ) &&
      !paperContractDocumentFile
    ) {
      ToastHelper.showError('Vui lòng tải lên hợp đồng scan');
      return;
    }

    if (!_.isEmpty(selectedFiles)) {
      selectFilePathList.current = [];
      await processSelectedFiles(selectedFiles);
    }
    setAllFiles([
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ]);
    const attachedFiles = [
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ];

    // kiem tra xem co tao lai hop dong khong?
    if (contractDetail?.status === AgencyConstants.ContractStatus.CREATED) {
      let contract = null;
      let createParams = {
        operatorId: contractDetail?.operatorId,
        saleId: contractDetail?.saleId,
        contractDate: contractDate,
        contractNumber: contractNumber,
        validFrom: validFrom,
        validTo: (contractDetail?.contractRole !== AgencyConstants.ContractRole.INVESTOR
          && contractDetail?.contractRole !== AgencyConstants.ContractRole.CHARGEPOINT) ? validTo : '',
        attachedFiles: attachedFiles,
        contractStatus: contractStatus,
        contractDocument: '',
        poaDocument: '',
      };
      if (contractType === AgencyConstants.ContractType.PAPER) {
        if (paperContractDocumentFile) {
          createParams.contractDocument = await handleUploadPaperContract(paperContractDocumentFile, contractNumber);
        }
        if (paperPOADocumentFile) {
          createParams.poaDocument = await uploadAsyncFunction(paperPOADocumentFile);
        }
      }
      createParams = _.pickBy(createParams, (value) => value !== '');
      setLoading(true);
      if (contractDetail?.contractRole === AgencyConstants.ContractRole.GROUP) {
        contract = await AgencyHelper.API.requestCreateGroupContract(createParams);
      } else if (contractDetail?.contractRole === AgencyConstants.ContractRole.INVESTOR) {
        contract = await AgencyHelper.API.requestCreateInvestorContract(createParams);
      }
      if (contract && _.isObject(contract)) {
        ToastHelper.showSuccess('Cập nhật hợp đồng thành công');
        // neu trang thai hop dong la COMPLETED thi chuyen trang thai don hang sang COMPLETED
        // if (contractStatus === AgencyConstants.ContractStatus.COMPLETED) {
        //   await AgencyHelper.API.requestUpdateSale(contractDetail?.saleId, {
        //     status: AgencyConstants.SaleOrderStatus.COMPLETED,
        //   });
        // }
        onConfirm();
      } else {
        ToastHelper.showError(contract || 'Cập nhật hợp đồng không thành công');
      }
      setLoading(false);
      return;
    }

    let updateParams = {
      contractNumber,
      contractDate,
      validFrom,
      validTo,
      status: contractStatus,
      attachedFiles: attachedFiles,
      contractDocument: '',
      poaDocument: '',
    };
    if (contractType === AgencyConstants.ContractType.PAPER) {
      if (paperContractDocumentFile) {
        updateParams.contractDocument = await handleUploadPaperContract(paperContractDocumentFile, contractNumber);
      }
      if (paperPOADocumentFile) {
        updateParams.poaDocument = await uploadAsyncFunction(paperPOADocumentFile);
      }
    }
    updateParams = _.pickBy(updateParams, (value) => value !== '');
    setLoading(true);
    const result = await AgencyHelper.API.requestUpdateContract(
      contractDetail?.contractId,
      updateParams
    );
    if (_.isObject(result)) {
      ToastHelper.showSuccess('Cập nhật hợp đồng thành công');
      // neu trang thai hop dong la COMPLETED thi chuyen trang thai don hang sang COMPLETED
      // if (contractStatus === AgencyConstants.ContractStatus.COMPLETED) {
      //   await AgencyHelper.API.requestUpdateSale(contractDetail?.saleId, {
      //     status: AgencyConstants.SaleOrderStatus.COMPLETED,
      //   });
      // }
      onConfirm();
    } else {
      ToastHelper.showError(result || 'Cập nhật hợp đồng không thành công');
    }
    setLoading(false);
  };
  const handleFilesChanged = (e) => {
    const newFiles = Array.from(e.target.files || []);

    const validFiles = newFiles.filter((file) => {
      if (file.name.length > 128) {
        ToastHelper.showError(`Tên file quá dài! Tối đa cho phép 128 ký tự.`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    setSelectedFiles((prev) => [...prev, ...validFiles]);
    setAllFiles((prev) => [...prev, ...validFiles]);
  };
  const handleRemoveAll = () => {
    setSelectedFiles([]);
  };
  const handleViewFile = (file) => {
    const url = URL.createObjectURL(file);
    if (url) {
      Utils.openInNewTab(url);
      URL.revokeObjectURL(url);
    }
  };
  const handleRemoveFile = (file) => {
    if (file instanceof File) {
      const tmpFiles = selectedFiles.filter((item) => item.lastModified !== file?.lastModified);
      setSelectedFiles(tmpFiles);
    }

    let newAllFiles = [...allFiles];
    if (typeof file === 'string') {
      newAllFiles = _.filter(allFiles, (item) => item !== file);
    }
    if (file instanceof File) {
      newAllFiles = _.filter(allFiles, (item) => item.lastModified !== file?.lastModified);
    }
    setAllFiles(newAllFiles);
  };
  async function processSelectedFiles(files) {
    for (const file of files) {
      const path = await uploadAsyncFunction(file);
      selectFilePathList.current?.push(path);
    }
  }
  async function uploadAsyncFunction(file) {
    return new Promise((resolve) => {
      if (file instanceof File) {
        miscHelper.callApiUploadFile(file).then((mediaList) => {
          if (_.isArray(mediaList) && mediaList.length > 0) {
            const firstMedia = _.first(mediaList);
            const relativePath = firstMedia?.relativePath;
            if (relativePath) {
              resolve(relativePath);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        });
      } else {
        resolve(file);
      }
    });
  }

  return (
    <div>
      <div className="row m-0">
        <div className="col-12 p-0">
          {/* trang thai hop dong */}
          <div className="mt-4 px-5">
            {UIHelper.buildFormLabel('Trạng thái hợp đồng', true)}
            <KTBSDropdown
              name="contractStatus"
              toggleElement={
                <button
                  className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${Utils.isValid(contractDetail) &&
                    contractDetail?.contractType === AgencyConstants.ContractType.DIGITAL
                    ? 'disabled'
                    : ''
                    }`}
                  type="button"
                >
                  {
                    _.find(
                      AgencyHelper.Data.contractOptions,
                      (item) => item.value === contractStatus
                    )?.name
                  }
                </button>
              }
              selectedValue={contractStatus}
              dropdownMenuItems={AgencyHelper.Data.contractOption[contractDetail?.status]}
              dropdownMenuClassName="overflow-auto w-100"
              dropdownMenuStyle={{ maxHeight: '30vh' }}
              onChange={(value) => {
                setContractStatus(value);
              }}
              isDropdownForm={true}
              disabled={
                Utils.isValid(contractDetail) &&
                contractDetail?.contractType === AgencyConstants.ContractType.DIGITAL
              }
            />
          </div>
          {/* ngay hop dong */}
          <div className="mt-4 px-5">
            {UIHelper.buildFormLabel('Ngày hợp đồng', true)}
            <KTFormInput
              name="contractDate"
              placeholder="Nhập ngày"
              type={KTFormInputType.date}
              value={contractDate}
              onChange={(value) => setContractDate(value)}
            />
          </div>
          {(contractDetail?.contractRole === AgencyConstants.SaleOrderType.INVESTOR ||
            contractDetail?.contractRole === AgencyConstants.SaleOrderType.CHARGEPOINT
          ) && (
              <div className="mt-4 px-5">
                {UIHelper.buildFormLabel('Ngày hiệu lực', true)}
                <KTFormInput
                  name="contractValidFrom"
                  placeholder="Nhập ngày hiệu lực"
                  type={KTFormInputType.date}
                  value={validFrom}
                  onChange={(value) => setValidFrom(value)}
                  minTime={contractDate}
                />
              </div>
            )}
          {/* so hop dong */}
          <div className="mt-4 px-5">
            {UIHelper.buildFormLabel('Số hợp đồng', true)}
            <KTFormInput
              name="contractNumber"
              placeholder="Nhập số hợp đồng"
              type={KTFormInputType.text}
              value={contractNumber}
              onChange={(value) => setContractNumber(value)}
            />
          </div>
          {/* ngay hieu luc va het hieu luc */}
          {(contractDetail?.contractRole !== AgencyConstants.SaleOrderType.INVESTOR &&
            contractDetail?.contractRole !== AgencyConstants.SaleOrderType.CHARGEPOINT
          ) && (
              <div className="row mx-0 mt-4 mb-0 p-0 px-5">
                <div className="col-6 pl-0 pr-2">
                  {UIHelper.buildFormLabel('Ngày hiệu lực', true)}
                  <KTFormInput
                    name="contractValidFrom"
                    placeholder="Nhập ngày hiệu lực"
                    type={KTFormInputType.date}
                    value={validFrom}
                    onChange={(value) => setValidFrom(value)}
                    minTime={contractDate}
                  />
                </div>
                <div className="col-6 pr-0 pl-2">
                  {UIHelper.buildFormLabel('Ngày hết hiệu lực', true)}
                  <KTFormInput
                    name="contractValidTo"
                    placeholder="Nhập ngày hết hiệu lực"
                    type={KTFormInputType.date}
                    value={validTo}
                    onChange={(value) => setValidTo(value)}
                    minTime={validFrom}
                  />
                </div>
              </div>
            )}

          {/* file dinh kem */}
          {contractType === AgencyConstants.ContractType.DIGITAL && (
            <div className="my-4">
              <div className="px-5">{UIHelper.buildFormLabel('Tập tin đính kèm')}</div>
              <div>
                {!_.isEmpty(allFiles) && (
                  <div className="row m-0 p-0 px-3">
                    {allFiles.map((item, index) => {
                      return (
                        <div className="p-0 col-6 mb-2 p-2" key={item?.lastModified ?? item ?? index}>
                          <ImageView
                            name={item?.lastModified ?? item ?? index}
                            path={_.isString(item) ? item : item?.name}
                            onRemove={() => {
                              handleRemoveFile(item);
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="d-flex px-5">
                  <label className="">
                    {UIHelper.buildNegativeButton(
                      'Thêm tập tin',
                      () => { },
                      <i className="fa-regular fa-upload" />
                    )}
                    <input
                      type="file"
                      accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                      onChange={handleFilesChanged}
                      multiple
                      hidden
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                    />
                  </label>
                </div>
              </div>
            </div>
          )}
          {contractType === AgencyConstants.ContractType.PAPER && (
            <div className="row m-0 p-0 px-3 my-4">
              {/* file hop dong */}
              <div className="col-6 p-0 px-2">
                <div>
                  {UIHelper.buildFormLabel('Tải lên hợp đồng scan', true)}
                  <label className="">
                    {UIHelper.buildNegativeButton(
                      'Thêm tập tin',
                      () => { },
                      <i className="fa-regular fa-upload" />
                    )}
                    <input
                      type="file"
                      accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                      onChange={(e) => {
                        const files = e.target.files;
                        if (!files || files.length === 0) return;
                        const file = files[0];
                        if (file.name.length > 128) {
                          ToastHelper.showError("Tên file quá dài! Tối đa cho phép 128 ký tự.");
                          e.target.value = null;
                          return;
                        }
                        setPaperContractDocumentFile(file);
                      }}
                      hidden
                      onClick={(e) => {
                        e.target.value = null;
                      }}
                    />
                  </label>
                  {paperContractDocumentFile && (
                    <div>
                      <ImageView
                        name={paperContractDocumentFile?.lastModified ?? paperContractDocumentFile}
                        path={
                          _.isString(paperContractDocumentFile)
                            ? paperContractDocumentFile.split('/').pop().replace(/\.pdf-.+$/, '.pdf')
                            : paperContractDocumentFile?.name
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* giay uy quyen */}
              {contractDetail?.contractRole === AgencyConstants.SaleOrderType.GROUP && (
                <div className="col-6 p-0 px-2">
                  <div>
                    {UIHelper.buildFormLabel('Tải lên giấy uỷ quyền', true)}
                    <label className="">
                      {UIHelper.buildNegativeButton(
                        'Thêm tập tin',
                        () => { },
                        <i className="fa-regular fa-upload" />
                      )}
                      <input
                        type="file"
                        accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                        onChange={(e) => {
                          const files = e.target.files;
                          if (!files || files.length === 0) return;
                          const file = files[0];
                          if (file.name.length > 128) {
                            ToastHelper.showError("Tên file quá dài! Tối đa cho phép 128 ký tự.");
                            e.target.value = null;
                            return;
                          }
                          setPaperPOADocumentFile(file);
                        }}
                        hidden
                        onClick={(e) => {
                          e.target.value = null;
                        }}
                      />
                    </label>
                    {paperPOADocumentFile && (
                      <div>
                        <ImageView
                          name={paperPOADocumentFile?.lastModified ?? paperPOADocumentFile}
                          path={
                            _.isString(paperPOADocumentFile)
                              ? paperPOADocumentFile.split('/').pop().replace(/\.pdf-.+$/, '.pdf')
                              : paperPOADocumentFile?.name
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Cập nhật', handleConfirm, null, true, loading)}
      </div>
    </div>
  );
}

export default AgencyContractEditView;
